import _ from 'lodash'

export default {
  state: {
    querysearch: '',
    typeview: 0,
    // filter: [],
    filtertopics: [],
    filtersubtopics: [],
    filtertags: [],
    filtercontenttypes: [],
    pagenumber: 1,
    mediatype: null,
    startyear: null,
    endyear: null,
    orderby: null,
    author: null,
    openfilter: false,
    searchType: null
  },
  mutations: {
    changePage(state, payload) {
      state.pagenumber = payload
    },
    changeText(state, payload) {
      state.querysearch = payload
    },
    changeTypeView(state, payload) {
      state.typeview = payload
    },
    changeYear(state, payload) {
      Object.assign(state, payload)
    },
    changeMediaType(state, payload) {
      Object.assign(state, payload)
    },
    changeOrderBy(state, payload) {
      Object.assign(state, payload)
    },
    changeAuthor(state, payload) {
      Object.assign(state, payload)
    },
    resetFilters(state, payload) {
      if (payload.all) {
        state.querysearch = ''
      }
      if (state.orderby) {
        state.orderby = null
      }
      if (state.pagenumber > 1) {
        state.pagenumber = 1
      }
      if (state.startyear) {
        state.startyear = null
      }
      if (state.endyear) {
        state.endyear = null
      }
      if (state.author) {
        state.author = ''
      }
      if (state.mediatype) {
        state.mediatype = null
      }

      // Reset filters
      if (!_.isUndefined(state.filtertopics) && state.filtertopics.length) {
        state.filtertopics.splice(0, state.filtertopics.length)
      }

      if (!_.isUndefined(state.filtersubtopics) && state.filtersubtopics.length) {
        state.filtersubtopics.splice(0, state.filtersubtopics.length)
      }

      if (!_.isUndefined(state.filtertags) && state.filtertags.length) {
        state.filtertags.splice(0, state.filtertags.length)
      }

      if (!_.isUndefined(state.filtercontenttypes) && state.filtercontenttypes.length) {
        state.filtercontenttypes.splice(0, state.filtercontenttypes.length)
      }
    },
    changeFilters(state, payload) {
      // Reset page
      if (state.pagenumber > 1) {
        state.pagenumber = 1
      }
      // Change filters
      const item = state[payload.name]

      if (_.includes(item, payload.value)) {
        item.splice(item.indexOf(payload.value), 1)
      } else {
        item.push(payload.value)
      }
    },
    openFilter(state, payload) {
      if (!_.isUndefined(payload)) {
        state.openfilter = payload
      } else {
        state.openfilter = !state.openfilter
      }
    },
    changeParams(state, payload) {
      Object.assign(state, payload)
    },
    initialize(state, payload) {
      Object.assign(state, payload)
    },
    changeSearchType(state, payload) {
      state.searchType = payload
    }
  },
  actions: {
    changePage({ commit }, payload) {
      commit('changePage', payload)
    },
    changeText({ commit }, payload) {
      commit('changeText', payload)
      commit('resetFilters', payload)
    },
    changeTypeView({ commit }, payload) {
      commit('changeTypeView', payload)
    },
    changeFilters({ commit }, payload) {
      commit('changeFilters', payload)
    },
    changeYear({ commit }, payload) {
      commit('changeYear', payload)
    },
    changeMediaType({ commit }, payload) {
      commit('changeMediaType', payload)
    },
    changeOrderBy({ commit }, payload) {
      commit('changeOrderBy', payload)
    },
    resetFilters({ commit }, payload) {
      commit('resetFilters', payload)
    },
    changeAuthor({ commit }, payload) {
      commit('changeAuthor', payload)
    },
    openFilter({ commit }, payload) {
      commit('openFilter', payload)
    },
    changeParams({ commit }, payload) {
      commit('changeParams', payload)
    },
    initialize({ commit }, payload) {
      if (_.isNaN(payload.pagenumber)) {
        delete payload.pagenumber
      }
      if (_.isNaN(payload.typeview)) {
        delete payload.typeview
      }
      if (_.isNaN(payload.startyear)) {
        delete payload.startyear
      }
      if (!_.isArray(payload.filtertopics)) {
        delete payload.filtertopics
      }
      if (!_.isArray(payload.filtersubtopics)) {
        delete payload.filtersubtopics
      }
      if (!_.isArray(payload.filtertags)) {
        delete payload.filtertags
      }
      if (!_.isArray(payload.filtercontenttypes)) {
        delete payload.filtercontenttypes
      }
      if (_.isNaN(payload.endyear)) {
        delete payload.endyear
      }
      if (_.isNaN(payload.orderby)) {
        delete payload.orderby
      }
      commit('initialize', payload)
    },
    changeSearchType({ commit }, payload) {
      commit('changeSearchType', payload)
    }
  },
  getters: {
    page: state => state.pagenumber,
    typeView: state => state.typeview,
    filtering: state => !!state.querysearch ||
                        !!state.filtertopics.length ||
                        !!state.filtersubtopics.length ||
                        !!state.filtertags.length ||
                        !!state.filtercontenttypes.length ||
                        state.startyear != null ||
                        state.endyear !== null ||
                        !!state.author ||
                        !!state.orderby ||
                        !!state.mediatype,
    filterIsOpen: state => state.openfilter,
    parameters: (state) => {
      return {
        querysearch: state.querysearch,
        filtertopics: state.filtertopics,
        filtersubtopics: state.filtersubtopics,
        filtertags: state.filtertags,
        filtercontenttypes: state.filtercontenttypes,
        pagenumber: state.pagenumber,
        mediatype: state.mediatype,
        startyear: state.startyear,
        endyear: state.endyear,
        orderby: state.orderby,
        author: state.author,
        searchType: state.searchType
      }
    }
  }
}
